<template>
  <div id="permits-licenses">
    HEAVY EQUIPMENT
  </div>
</template>

<script>
export default {

}
</script>

<style>
#permits-licenses{
    width: 95%;
    margin: auto;
    border: 1px solid black;
    height: 300px;
}
</style>